import { Box } from '@mui/material';

/** Colored 7px status dot with halo. */
export default function StatusDot({ color }: { color: string }) {
    return (
        <Box
            component="span"
            sx={{
                width: 7,
                height: 7,
                borderRadius: '50%',
                bgcolor: color,
                flexShrink: 0,
                boxShadow: `0 0 0 1px ${color}33`,
            }}
        />
    );
}
